/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LootBoxInstanceResponse } from './LootBoxInstanceResponse';
import {
    LootBoxInstanceResponseFromJSON,
    LootBoxInstanceResponseFromJSONTyped,
    LootBoxInstanceResponseToJSON,
    LootBoxInstanceResponseToJSONTyped,
} from './LootBoxInstanceResponse';

/**
 * 
 * @export
 * @interface GrantLootBoxInstanceResponse
 */
export interface GrantLootBoxInstanceResponse {
    /**
     * 
     * @type {LootBoxInstanceResponse}
     * @memberof GrantLootBoxInstanceResponse
     */
    instance: LootBoxInstanceResponse;
}

/**
 * Check if a given object implements the GrantLootBoxInstanceResponse interface.
 */
export function instanceOfGrantLootBoxInstanceResponse(value: object): value is GrantLootBoxInstanceResponse {
    if (!('instance' in value) || value['instance'] === undefined) return false;
    return true;
}

export function GrantLootBoxInstanceResponseFromJSON(json: any): GrantLootBoxInstanceResponse {
    return GrantLootBoxInstanceResponseFromJSONTyped(json, false);
}

export function GrantLootBoxInstanceResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GrantLootBoxInstanceResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'instance': LootBoxInstanceResponseFromJSON(json['instance']),
    };
}

export function GrantLootBoxInstanceResponseToJSON(json: any): GrantLootBoxInstanceResponse {
    return GrantLootBoxInstanceResponseToJSONTyped(json, false);
}

export function GrantLootBoxInstanceResponseToJSONTyped(value?: GrantLootBoxInstanceResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'instance': LootBoxInstanceResponseToJSON(value['instance']),
    };
}

